import React from 'react';
import {AnnouncementDetailContent} from './sub-view/announcement-content';
import {UserLayout} from 'components/layouts/user';

class AnnouncementDetailContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active="announcements">
        <h1 className="user-header">Chi tiết thông báo</h1>
        <AnnouncementDetailContent params={this.props.params}/>
      </UserLayout>
    );
  }
}

export default AnnouncementDetailContainer;



// WEBPACK FOOTER //
// ./components/users/AnnouncementDetailContainer.jsx